module.exports = __webpack_public_path__ + "img/fira-image-a.b48a9c14.png";